import React, { useState, useEffect } from "react"
import "./PasswordGate.scss"

const SESSION_KEY = "pionero_preview_"

const PasswordGate = ({ password, proyectoId, children }) => {
  const sessionKey = `${SESSION_KEY}${proyectoId}`
  const [unlocked, setUnlocked] = useState(false)
  const [input, setInput] = useState("")
  const [error, setError] = useState(false)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const saved = sessionStorage.getItem(sessionKey)
      if (saved === password) {
        setUnlocked(true)
      }
    }
  }, [sessionKey, password])

  const handleSubmit = e => {
    e.preventDefault()
    if (input.trim() === password) {
      sessionStorage.setItem(sessionKey, password)
      setUnlocked(true)
      setError(false)
    } else {
      setError(true)
      setInput("")
    }
  }

  if (unlocked) return <>{children}</>

  return (
    <div className="password-gate">
      <div className="password-gate__inner">
        <p className="password-gate__label font-roboto">Proyecto en preventa exclusiva</p>
        <h2 className="password-gate__title font-roboto">Acceso restringido</h2>
        <p className="password-gate__desc font-lato">
          Este proyecto está disponible solo para clientes con acceso previo.
          Ingresa la contraseña para continuar.
        </p>
        <form className="password-gate__form" onSubmit={handleSubmit}>
          <input
            className={`password-gate__input font-lato${error ? " password-gate__input--error" : ""}`}
            type="password"
            placeholder="Contraseña"
            value={input}
            onChange={e => {
              setInput(e.target.value)
              setError(false)
            }}
            autoFocus
          />
          {error && (
            <p className="password-gate__error font-lato">Contraseña incorrecta. Inténtalo de nuevo.</p>
          )}
          <button className="password-gate__btn font-lato" type="submit">
            Ingresar
          </button>
        </form>
      </div>
    </div>
  )
}

export default PasswordGate
